import {
  faTwitter,
  faFacebookSquare,
  faYoutube,
  faInstagram,
  faPinterest,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faDesktop, faHandHoldingHeart } from "@fortawesome/pro-light-svg-icons";
import {
  faCloudDownload,
  faDollarSign,
  faLeaf,
  faNewspaper,
  faClipboardListCheck,
  faPhoneLaptop,
  faSearch,
  faUser,
  faUserDoctor,
  faLaptopCode,
  faPhotoFilm,
} from "@fortawesome/pro-regular-svg-icons";

import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { l } from "@unauthenticated/catalog/locales/i18n";

import type { HeaderMenuLink, FooterMenuLink, SocialMenuLink } from "./MenuLinks.types";

const headerProductLinks: HeaderMenuLink[] = [
  {
    key: l.navigation.MenuItems.Pricing,
    title: l.navigation.MenuItems.Pricing,
    description: l.navigation.MenuItems.Product1,
    link: openCatalogRoutes.pricing,
    icon: faDollarSign,
  },
  {
    key: l.navigation.MenuItems.Integrations,
    title: l.navigation.MenuItems.Integrations,
    description: l.navigation.MenuItems.Product2,
    link: openCatalogRoutes.integrations,
    icon: faLaptopCode,
  },
  {
    key: l.navigation.MenuItems.Patients,
    title: l.navigation.MenuItems.Patients,
    description: l.navigation.MenuItems.Product3,
    link: openCatalogRoutes.patients,
    icon: faHandHoldingHeart,
  },
  {
    key: l.navigation.MenuItems.BookADemo,
    title: l.navigation.MenuItems.BookADemo,
    description: l.navigation.MenuItems.Product4,
    link: openCatalogRoutes.demo,
    icon: faPhoneLaptop,
  },
];

const headerLearnLinks1: HeaderMenuLink[] = [
  {
    key: l.navigation.MenuItems.Spotlight,
    title: l.navigation.MenuItems.Spotlight,
    description: l.navigation.MenuItems.Learn1,
    link: openCatalogRoutes.spotlight,
    icon: faSearch,
  },
  {
    key: l.navigation.MenuItems.WellnessBlog,
    title: l.navigation.MenuItems.WellnessBlog,
    description: l.navigation.MenuItems.Learn2,
    link: openCatalogRoutes.education,
    icon: faNewspaper,
  },
  {
    key: l.navigation.MenuItems.Webinars,
    title: l.navigation.MenuItems.Webinars,
    description: l.navigation.MenuItems.Learn7,
    link: openCatalogRoutes.webinars,
    icon: faPhotoFilm,
  },
];

const headerLearnLinks2: HeaderMenuLink[] = [
  {
    key: l.navigation.MenuItems.Protocols,
    title: l.navigation.MenuItems.Protocols,
    description: l.navigation.MenuItems.Learn4,
    link: openCatalogRoutes.protocols,
    icon: faClipboardListCheck,
  },
  {
    key: l.navigation.MenuItems.PracticeResources,
    title: l.navigation.MenuItems.PracticeResources,
    description: l.navigation.MenuItems.Learn5,
    link: openCatalogRoutes.practiceResources,
    icon: faCloudDownload,
  },
  {
    key: l.navigation.MenuItems.IngredientLibrary,
    title: l.navigation.MenuItems.IngredientLibrary,
    description: l.navigation.MenuItems.Learn6,
    link: openCatalogRoutes.ingredientLib,
    icon: faLeaf,
  },
  {
    key: l.navigation.MenuItems.PracticingVirtually,
    title: l.navigation.MenuItems.PracticingVirtually,
    description: l.navigation.MenuItems.Learn3,
    link: openCatalogRoutes.practicingVirtually,
    icon: faDesktop,
  },
];

const mobileHeaderLearnLinks: HeaderMenuLink[] = [
  {
    key: l.navigation.MenuItems.Spotlight,
    title: l.navigation.MenuItems.Spotlight,
    description: l.navigation.MenuItems.Learn1,
    link: openCatalogRoutes.spotlight,
    icon: faSearch,
  },
  {
    key: l.navigation.MenuItems.Protocols,
    title: l.navigation.MenuItems.Protocols,
    description: l.navigation.MenuItems.Learn4,
    link: openCatalogRoutes.protocols,
    icon: faClipboardListCheck,
  },
  {
    key: l.navigation.MenuItems.WellnessBlog,
    title: l.navigation.MenuItems.WellnessBlog,
    description: l.navigation.MenuItems.Learn2,
    link: openCatalogRoutes.education,
    icon: faNewspaper,
  },
  {
    key: l.navigation.MenuItems.PracticeResources,
    title: l.navigation.MenuItems.PracticeResources,
    description: l.navigation.MenuItems.Learn5,
    link: openCatalogRoutes.practiceResources,
    icon: faCloudDownload,
  },
  {
    key: l.navigation.MenuItems.Webinars,
    title: l.navigation.MenuItems.Webinars,
    description: l.navigation.MenuItems.Learn7,
    link: openCatalogRoutes.webinars,
    icon: faPhotoFilm,
  },
  {
    key: l.navigation.MenuItems.IngredientLibrary,
    title: l.navigation.MenuItems.IngredientLibrary,
    description: l.navigation.MenuItems.Learn6,
    link: openCatalogRoutes.ingredientLib,
    icon: faLeaf,
  },
  {
    key: l.navigation.MenuItems.PracticingVirtually,
    title: l.navigation.MenuItems.PracticingVirtually,
    description: l.navigation.MenuItems.Learn3,
    link: openCatalogRoutes.practicingVirtually,
    icon: faDesktop,
  },
];

const headerSupportLinks: HeaderMenuLink[] = [
  {
    key: l.navigation.MenuItems.PractitionerSupport,
    title: l.navigation.MenuItems.PractitionerSupport,
    description: l.navigation.MenuItems.Support1,
    link: openCatalogRoutes.supportPractitioner,
    icon: faUserDoctor,
  },
  {
    key: l.navigation.MenuItems.PatientHelp,
    title: l.navigation.MenuItems.PatientHelp,
    description: l.navigation.MenuItems.Support2,
    link: openCatalogRoutes.supportPatient,
    icon: faUser,
  },
];

const companyLinks: FooterMenuLink[] = [
  {
    link: openCatalogRoutes.spotlight,
    text: l.navigation.Spotlight,
  },
  {
    link: openCatalogRoutes.about,
    text: l.navigation.AboutFullscript,
  },
  {
    link: openCatalogRoutes.collective,
    text: l.navigation.Collective,
  },
  {
    link: openCatalogRoutes.leadership,
    text: l.navigation.Leadership,
  },
  {
    link: openCatalogRoutes.culture,
    text: l.navigation.CultureGuide,
  },
  {
    link: openCatalogRoutes.careers,
    text: l.navigation.Careers,
  },
  {
    link: openCatalogRoutes.engineering,
    text: l.navigation.EngineeringCulture,
  },
  {
    link: openCatalogRoutes.news,
    text: l.navigation.News,
  },
];

const supportLinks: FooterMenuLink[] = [
  {
    link: openCatalogRoutes.supportPractitioner,
    text: l.navigation.PractitionerSupport,
  },
  {
    link: openCatalogRoutes.supportPatient,
    text: l.navigation.PatientHelp,
  },
  {
    link: openCatalogRoutes.testimonials,
    text: l.navigation.Testimonials,
  },
  {
    link: openCatalogRoutes.faq,
    text: l.navigation.GeneralFAQ,
  },
  {
    link: openCatalogRoutes.shippingPolicy,
    text: l.navigation.PatientShipping,
  },
  {
    link: openCatalogRoutes.wholesaleShipping,
    text: l.navigation.WholesaleShipping,
  },
];

const productLinks: FooterMenuLink[] = [
  {
    link: openCatalogRoutes.howItWorks,
    text: l.navigation.PractitionerSoftware,
  },
  {
    link: openCatalogRoutes.integrations,
    text: l.navigation.Integrations,
  },
  {
    link: openCatalogRoutes.pricing,
    text: l.navigation.Pricing,
  },
  {
    link: openCatalogRoutes.patients,
    text: l.navigation.Patients,
  },
  {
    link: openCatalogRoutes.supplementQuality,
    text: l.navigation.SupplementQuality,
  },
  {
    link: openCatalogRoutes.treatmentAdherence,
    text: l.navigation.TreatmentAdherence,
  },
  {
    link: openCatalogRoutes.catalog,
    text: l.navigation.Catalog,
  },
  {
    link: openCatalogRoutes.wholesale,
    text: l.navigation.Wholesale,
  },
];

const socialLinks: SocialMenuLink[] = [
  {
    link: openCatalogRoutes.instagram,
    label: l.navigation.Instagram,
    icon: faInstagram,
  },
  {
    link: openCatalogRoutes.facebook,
    label: l.navigation.Facebook,
    icon: faFacebookSquare,
  },
  {
    link: openCatalogRoutes.youtube,
    label: l.navigation.YouTube,
    icon: faYoutube,
  },
  {
    link: openCatalogRoutes.linkedin,
    label: l.navigation.LinkedIn,
    icon: faLinkedin,
  },
  {
    link: openCatalogRoutes.pinterest,
    label: l.navigation.Pinterest,
    icon: faPinterest,
  },
  {
    link: openCatalogRoutes.twitter,
    label: l.navigation.Twitter,
    icon: faTwitter,
  },
];

export {
  headerProductLinks,
  headerLearnLinks1,
  headerLearnLinks2,
  mobileHeaderLearnLinks,
  headerSupportLinks,
  socialLinks,
  productLinks,
  supportLinks,
  companyLinks,
};
